/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useEntitiesListStyles = makeStyles(() => ({
  root: {},
  itemWrap: {
    marginTop: '10px',
    '&:first-child': {
      marginTop: 0,
    },
  },
  itemRoot: {
    padding: '10px',
    paddingLeft: '56px',
    borderRadius: '6px',
    backgroundColor: '#F6F7F8',
    minHeight: '52px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    justifyContent: 'flex-start',
  },
  itemIcon: {
    width: '32px',
    height: '32px',
    overflow: 'hidden',
    borderRadius: '6px',
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  itemText: {
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'left',
  },
}));
